import { stepCollisionDamageStarrLookup as expenseLookup } from './claimCodeMapper';

function mapToParentSection() {
  return {};
}

function mapToQuestionnaire() {
  return [];
}

function mapToExpenses(data) {
  const collisionDamageExpenses = mapToCollisionDamageExpenses(data);
  return [...collisionDamageExpenses];
}

function mapToClaimExpensesLevel(data, claimTypes, selectedBenefits) {
  const { areYouClaimingForRentalCarDamage } = data;
  const list = [];
  const selected =
    !!selectedBenefits && typeof selectedBenefits.toJS === 'function'
      ? selectedBenefits.toJS()
      : selectedBenefits || [];
  const claimCodeList = expenseLookup.claimCodeList;
  if (selected.length > 0 && !selected.some((sel) => claimCodeList.includes(sel.claimCode))
  ) {
    return list;
  }
  if ((areYouClaimingForRentalCarDamage === 'true') && claimTypes !== undefined) {
    const code1 = expenseLookup.collisionDamage.claimCode;
    const collisionDamageExpenses = mapToCollisionDamageExpenses(data);
    claimTypes.forEach(
      (item) => {
        if (item.claimCode === code1 && areYouClaimingForRentalCarDamage === 'true') {
          const benefit = mapClaimExpensesLevelItem(item, 'Collision Damage', collisionDamageExpenses);
          if (!!benefit) {
            list.push(benefit);
          }
        }
      }
    );
  }

  return list;
}

function mapToCollisionDamageExpenses(data) {
  if (data.areYouClaimingForRentalCarDamage !== 'true' || data.expenseDescriptionOfItems.length < 1) {
    return [];
  }
  const claimCode = expenseLookup.collisionDamage.claimCode;
  const expenses = [];

  data.expenseDescriptionOfItems.forEach(
    (item) => {
      const expense = mapCollisionDamageExpense(item, data, claimCode);
      if (!!expense) {
        expenses.push(expense);
      }

      const reimburseExpense = mapReimbursement(item, data, claimCode);
      if (!!reimburseExpense) {
        expenses.push(reimburseExpense);
      }
    }
  );

  return expenses;
}

function mapCollisionDamageExpense(item, formData, claimCode) {
  return mapExpenseItem(item, formData.dateTripInterrupted, claimCode);
}

function mapExpenseItem(item, itemDate, claimCode) {
  const selectedClaimForArray = item.selectedClaimFor ? (!Array.isArray(item.selectedClaimFor)) ? item.selectedClaimFor.toJS() : item.selectedClaimFor : [];
  const claimForInsuredIds = selectedClaimForArray.map((claimFor) => claimFor.policyRoleID);
  if (!item || !item.estimatedValue || !item.currentEstimated) {
    return null;
  }
  return {
    shortDescription: item.itemDescription,
    dateOfExpense: item.dateOfLoss,
    clientCost: item.estimatedValue,
    currency: item.currentEstimated,
    rate: null,
    requestedAmount: null,
    claimTypeCode: claimCode,
    claimForInsuredIds,
    claimForInsureds: selectedClaimForArray,
  };
}

function mapReimbursement(item, formData, claimCode) {
  const selectedClaimForArray = item.selectedClaimFor ? (!Array.isArray(item.selectedClaimFor)) ? item.selectedClaimFor.toJS() : item.selectedClaimFor : [];
  const claimForInsuredIds = selectedClaimForArray.map((claimFor) => claimFor.policyRoleID);
  if (!item || !item.howMuchReceivedReimbursement || !item.currentReceivedReimbursement || item.haveYouReceivedReimbursement !== 'true') {
    return null;
  }
  return {
    shortDescription: `${item.fromWhomReceivedReimbursement} (Reimbursement)`,
    dateOfExpense: item.dateReimbursementReceived,
    clientCost: `${item.howMuchReceivedReimbursement * -1}`,
    currency: item.currentReceivedReimbursement,
    rate: null,
    requestedAmount: null,
    claimTypeCode: claimCode,
    claimForInsuredIds,
    claimForInsureds: selectedClaimForArray,
  };
}

function mapClaimExpensesLevelItem(claimType, description, expenses) {
  return {
    claimCode: claimType.claimCode,
    description,
    claimTypeId: claimType.claimTypeId,
    requiredDocuments: claimType.requiredDocuments,
    order: null,
    expenses: expenses || [],
  };
}

export default {
  mapToParentSection,
  mapToQuestionnaire,
  mapToExpenses,
  mapToClaimExpensesLevel,
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/dataMapper/stepCollisionDamageStarrDataMapper.js